import {useState} from 'react';

import {DevStuff} from '~/features/Dev/DevStuff';
import {ENVIRONMENT, IS_PROD} from '~/modules/config';
import {useAuth, useSideDrawer} from '~/store/hooks';

export const Header = () => {
  const [devStuffState, setDevStuffState] = useState({
    clickCount: 0,
    devStuffDisplayed: false,
  });

  const {authenticated} = useAuth();

  const {isSideDrawerOpen, onOpenSideDrawer, onCloseSideDrawer} =
    useSideDrawer();

  function onClickBadge() {
    setDevStuffState(curr => {
      let clickCount = curr.clickCount + 1;
      let devStuffDisplayed = false;
      if (clickCount > 5) {
        clickCount = 0;
        devStuffDisplayed = true;
      }
      return {
        clickCount,
        devStuffDisplayed,
      };
    });
  }

  return (
    <>
      <header
        className={
          IS_PROD ? `border-b-primary border-b-4` : `border-b-accent border-b-4`
        }>
        <div className="flex flex-row justify-between items-center p-4">
          <div className="flex flex-row gap-4 items-center">
            {authenticated && (
              <button
                tabIndex={1}
                className={`btn btn-circle swap swap-rotate ${
                  isSideDrawerOpen ? 'swap-active' : ''
                }`}
                onClick={
                  isSideDrawerOpen ? onCloseSideDrawer : onOpenSideDrawer
                }>
                {/* hamburger icon */}
                <svg
                  className="swap-off fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 512 512">
                  <path d="M64,384H448V341.33H64Zm0-106.67H448V234.67H64ZM64,128v42.67H448V128Z" />
                </svg>

                {/* close icon */}
                <svg
                  className="swap-on fill-current"
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 512 512">
                  <polygon points="400 145.49 366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49" />
                </svg>
              </button>
            )}

            <a href="/">
              <h1 className="text-lg">Gertrude 👵🏼</h1>
            </a>

            <div
              className={IS_PROD ? 'badge badge-primary' : 'badge badge-accent'}
              onClick={onClickBadge}>
              {ENVIRONMENT?.toUpperCase()}
            </div>
          </div>
        </div>
      </header>
      {devStuffState.devStuffDisplayed && <DevStuff />}
    </>
  );
};
